import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Scheduleponvvaltzkys as Schedule,
  ID1z61wlmtvxrjn as ID,
  ID__hashCode_impl_f4lulz3s4hpwy6rxg06 as ID__hashCode_impl_f4lulz,
  IDqqik72jjbpsn as ID_0,
  CareLocation1v3u5wduz023s as CareLocation,
  ID39tz9k5ges9xc as ID_1,
  ID1lyj7m2ox8cp5 as ID_2,
  Grant2zfdfpt9q1mly as Grant,
  IDknm0szoty74n as ID_3,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  ID1m87d1hextx54 as ID_4,
  ID2llykdzmszlol as ID_5,
  FamilyEmployerAuthorizationz43b3id5q687 as FamilyEmployerAuthorization,
  IDjecfjjw6mot9 as ID_6,
  Employer27b20p5x27kte as Employer,
  Day3noovgzg10lns as Day,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  minushnjyym3nfk5o as minus,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  ID3lnbkn76l7dgd as ID_7,
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
} from '../../strings.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_DAYS_getInstance3he068lsy3pdd as DurationUnit_DAYS_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
} from '../components/view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  get_scrollingHorizontally27coz76tiofr2 as get_scrollingHorizontally,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name29bc1mdqu6171 as get_name,
  get_name2gnjdlpbm0se5 as get_name_0,
  get__idsxxkn2fqoor7 as get__id,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_family2au8kxs7mi7t5 as get_family,
  get_location2f1azencio7x2 as get_location,
  get__id1hi7gtah39onn as get__id_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  xDataClassPathContainsCased3loynnz3n7tb9 as xDataClassPathContainsCased,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
  eq353yrgcpovoi1 as eq,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  TableSemantic_getInstance3cbunlgg7bvuu as TableSemantic_getInstance,
  TableRowSemantic_getInstance396gywh21vbqh as TableRowSemantic_getInstance,
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
  ShadedSemantic_getInstance1fiswfajryzey as ShadedSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  flatten2dh4kibw1u0qq as flatten,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  plus20p0vtfmu0596 as plus_0,
  plus310ted5e4i90h as plus_1,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  asSequence2phdjljfh9jhx as asSequence,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CareTime_FullTime_getInstance2puuq5c8w5gwp as CareTime_FullTime_getInstance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ChildDetailPage3f2al5z4lb3ic as ChildDetailPage } from './ChildDetailPage.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import {
  nowLocal2mdv5rmil2cf2 as nowLocal,
  today1rno4frfjp5oe as today,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { LocalDateRangefowoyqa24icz as LocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  filterNotNull7zp8mkmr5zva as filterNotNull,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  sequenceOfdrc6uefhtiet as sequenceOf,
  sequenceOf1mtha40gp6gat as sequenceOf_0,
  flatten21nlxz4anepug as flatten_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_entries2ar453qbk297a as get_entries,
  DayOfWeek_SUNDAY_getInstance2wrn9wqlq8qv4 as DayOfWeek_SUNDAY_getInstance,
  DayOfWeek_MONDAY_getInstance3u0uptycixs65 as DayOfWeek_MONDAY_getInstance,
  DayOfWeek_TUESDAY_getInstanceyj9r0qh47k6j as DayOfWeek_TUESDAY_getInstance,
  DayOfWeek_WEDNESDAY_getInstancewvb0t9y8yjce as DayOfWeek_WEDNESDAY_getInstance,
  DayOfWeek_THURSDAY_getInstance2fa72o4vitekp as DayOfWeek_THURSDAY_getInstance,
  DayOfWeek_FRIDAY_getInstance3psmv5z0rk53n as DayOfWeek_FRIDAY_getInstance,
  DayOfWeek_SATURDAY_getInstance2pwh8d7e3vqkf as DayOfWeek_SATURDAY_getInstance,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { renderToString5s2ibn3uk3ah as renderToString_0 } from '../../utils/daterender.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { reactiveSuspendingtu9o1tcdi36e as reactiveSuspending } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { multiSelectField3k4a6cedyq3tl as multiSelectField } from './placementComponents.mjs';
import { titleCase2ywrimcithmnb as titleCase } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/Annotations.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NewPlacementDraftClass;
function NewPlacementDraft() {
  if (NewPlacementDraftClass === VOID) {
    class $ {
      constructor(location, schedule, authorizations, grants, activeRange) {
        location = location === VOID ? null : location;
        schedule = schedule === VOID ? new (Schedule())() : schedule;
        var tmp;
        if (authorizations === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = authorizations;
        }
        authorizations = tmp;
        var tmp_0;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = grants;
        }
        grants = tmp_0;
        this.location_1 = location;
        this.schedule_1 = schedule;
        this.authorizations_1 = authorizations;
        this.grants_1 = grants;
        this.activeRange_1 = activeRange;
      }
      copy_ucv42j_k$(location, schedule, authorizations, grants, activeRange) {
        return new (NewPlacementDraft())(location, schedule, authorizations, grants, activeRange);
      }
      copy$default_164e4b_k$(location, schedule, authorizations, grants, activeRange, $super) {
        location = location === VOID ? this.location_1 : location;
        schedule = schedule === VOID ? this.schedule_1 : schedule;
        authorizations = authorizations === VOID ? this.authorizations_1 : authorizations;
        grants = grants === VOID ? this.grants_1 : grants;
        activeRange = activeRange === VOID ? this.activeRange_1 : activeRange;
        var tmp;
        if ($super === VOID) {
          tmp = this.copy_ucv42j_k$(location, schedule, authorizations, grants, activeRange);
        } else {
          var tmp_0 = $super.copy_ucv42j_k$;
          var tmp_1 = location;
          tmp = tmp_0.call(this, tmp_1 == null ? null : new (ID())(tmp_1), schedule, authorizations, grants, activeRange);
        }
        return tmp;
      }
      toString() {
        var tmp = this.location_1;
        return 'NewPlacementDraft(location=' + toString(tmp == null ? null : new (ID())(tmp)) + ', schedule=' + this.schedule_1.toString() + ', authorizations=' + toString_0(this.authorizations_1) + ', grants=' + toString_0(this.grants_1) + ', activeRange=' + this.activeRange_1.toString() + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.location_1;
        if ((tmp_0 == null ? null : new (ID())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = ID__hashCode_impl_f4lulz(this.location_1);
        }
        var result = tmp;
        result = imul(result, 31) + this.schedule_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.authorizations_1) | 0;
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + this.activeRange_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NewPlacementDraft()))
          return false;
        var tmp = this.location_1;
        var tmp_0 = tmp == null ? null : new (ID())(tmp);
        var tmp_1 = other.location_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID())(tmp_1)))
          return false;
        if (!this.schedule_1.equals(other.schedule_1))
          return false;
        if (!equals(this.authorizations_1, other.authorizations_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!this.activeRange_1.equals(other.activeRange_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NewPlacementDraft');
    NewPlacementDraftClass = $;
  }
  return NewPlacementDraftClass;
}
function fitsChild($this, $receiver, program) {
  var start = $receiver.invoke_r7m7el_k$($this.placement_1).activeRange_1.start_1;
  var birthDate = $receiver.invoke_r7m7el_k$($this.child_1).birthDate_1;
  var tmp0_safe_receiver = program.ageStart_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = start.compareTo_e7gwgq_k$(plus(birthDate, tmp0_safe_receiver)) >= 0;
  }
  var tmp1_elvis_lhs = tmp;
  var oldEnough = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  var tmp2_safe_receiver = program.ageEndInclusive_1;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = start.compareTo_e7gwgq_k$(plus(birthDate, tmp2_safe_receiver)) <= 0;
  }
  var tmp3_elvis_lhs = tmp_0;
  var youngEnough = tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
  return oldEnough && youngEnough;
}
function programNamed($this, id) {
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp($this.locationPrograms_1.get_state_wc71uu_k$());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        var tmp_0 = id;
        if (equals(new (ID_7())(element._id_1), tmp_0 == null ? null : new (ID_7())(tmp_0))) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
var MaxEndDateClass;
function MaxEndDate() {
  if (MaxEndDateClass === VOID) {
    class $ {
      constructor(date, program, authorization) {
        program = program === VOID ? null : program;
        authorization = authorization === VOID ? null : authorization;
        this.date_1 = date;
        this.program_1 = program;
        this.authorization_1 = authorization;
      }
      toString() {
        return 'MaxEndDate(date=' + this.date_1.toString() + ', program=' + toString(this.program_1) + ', authorization=' + toString(this.authorization_1) + ')';
      }
      hashCode() {
        var result = this.date_1.hashCode();
        result = imul(result, 31) + (this.program_1 == null ? 0 : this.program_1.hashCode()) | 0;
        result = imul(result, 31) + (this.authorization_1 == null ? 0 : this.authorization_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MaxEndDate()))
          return false;
        if (!this.date_1.equals(other.date_1))
          return false;
        if (!equals(this.program_1, other.program_1))
          return false;
        if (!equals(this.authorization_1, other.authorization_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MaxEndDate');
    MaxEndDateClass = $;
  }
  return MaxEndDateClass;
}
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, NewChildPlacementPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, NewChildPlacementPage$actionBar$slambda(element_0, $this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, NewChildPlacementPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  onClick(element_3, VOID, VOID, VOID, NewChildPlacementPage$actionBar$slambda_0($this, element_3));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function NewChildPlacementPage$_get_title_$lambda_rvokn2($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementNewTitle_31boj8_k$();
}
function NewChildPlacementPage$familyAuthorizations$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.activeRange_1.start_1;
  var tmp$ret$2 = a.activeRange_1.start_1;
  return compareValues(tmp, tmp$ret$2);
}
function NewChildPlacementPage$locationLens$lambda(it) {
  var tmp = it.location_1;
  return tmp == null ? null : new (ID())(tmp);
}
function NewChildPlacementPage$locationLens$lambda_0(old, new_0) {
  var tmp = new_0;
  return old.copy$default_164e4b_k$(tmp == null ? null : tmp.raw_1);
}
function NewChildPlacementPage$authorizationsLens$lambda(it) {
  return it.authorizations_1;
}
function NewChildPlacementPage$authorizationsLens$lambda_0(old, new_0) {
  return old.copy$default_164e4b_k$(VOID, VOID, new_0);
}
function NewChildPlacementPage$grantsLens$lambda(it) {
  return it.grants_1;
}
function NewChildPlacementPage$grantsLens$lambda_0(old, new_0) {
  return old.copy$default_164e4b_k$(VOID, VOID, VOID, new_0);
}
function NewChildPlacementPage$maxEndDate$lambda$lambda(it) {
  return new (MaxEndDate())(it.first_1.activeRange_1.endInclusive_1, VOID, it.first_1);
}
function invoke$name(_this__u8e3s4, $this_remember) {
  var tmp = $this_remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
  // Inline function 'kotlin.time.Companion.days' call
  Companion_getInstance_0();
  var tmp_0 = toDuration(1, DurationUnit_DAYS_getInstance());
  // Inline function 'kotlin.time.Companion.days' call
  Companion_getInstance_0();
  var tmp$ret$1 = toDuration(1, DurationUnit_DAYS_getInstance());
  var tmp0_safe_receiver = $this_remember.invoke_r7m7el_k$(tmp.item_eropyg_k$(new (ID_0())(_this__u8e3s4), tmp_0, tmp$ret$1));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
  return tmp1_elvis_lhs == null ? '<missing>' : tmp1_elvis_lhs;
}
function render$weekday(schedule, day) {
  var tmp = (it) => it.get_riprg6_k$(day);
  return schedule.lens_u4wb4z_k$(tmp, (old, new_0) => old.copy_tnb36q_k$(day, new_0));
}
function NewChildPlacementPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementDetailsHeading_3qgx4s_k$();
}
function NewChildPlacementPage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementCareLocationLabel_w1cbma_k$();
}
function NewChildPlacementPage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSearchIconDescription_uuv8wx_k$();
}
function NewChildPlacementPage$render$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementChooseCareLocationTitle_7rzjtt_k$();
}
function NewChildPlacementPage$render$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSearchIconDescription_uuv8wx_k$();
}
function TextInput$_get_hint_$ref_uvwrja(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.native_1.attributes_1.native_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 154, VOID, [p0]);
}
function TextInput$_set_hint_$ref_i30g2i(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.native_1.attributes_1.native_1.placeholder = p0_0;
    return Unit_instance;
  }, 1, 0, 155, VOID, [p0]);
}
function NewChildPlacementPage$render$slambda$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSearchLocationHint_kl76yo_k$();
}
function NewChildPlacementPage$render$slambda$lambda$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementNoCareLocationsMatch_lqc8l_k$();
}
function NewChildPlacementPage$render$slambda$lambda$lambda$slambda(this$0, $loc, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $loc;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* this$0.locationLens_1.set_revjhg_k$(new (ID())(tmp$ret$0._id_1), $completion);
    $close();
    return Unit_instance;
  }), 0);
}
function NewChildPlacementPage$render$slambda$lambda$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewChildPlacementPage$render$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function NewChildPlacementPage$render$slambda($$this$button, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, close) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, NewChildPlacementPage$render$slambda$lambda$lambda);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      var query = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
      var queryDebounced = element.debounce_nclnee_k$(query, 300n);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_1 = themed(element, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_1.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var this_2 = get_centered(element_1);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (IconView())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_2.willAddChild_hz2iwc_k$(element_2);
      element_2.set_source_3o5lkf_k$(Companion_getInstance_1().search_1.resize_q1xpz0_k$(get_rem(1.25)));
      var tmp_2 = KMutableProperty0();
      var tmp_3 = IconView$_get_description_$ref_x7iif6(element_2);
      var tmp_4 = getPropertyCallableRef('description', 0, tmp_2, tmp_3, IconView$_set_description_$ref_rpvc1e(element_2));
      element_2.invoke_bnq13k_k$(tmp_4, NewChildPlacementPage$render$slambda$lambda$lambda_0);
      element_2.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_2);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
      var this_3 = weight(element_1, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (TextInput())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      this_3.willAddChild_hz2iwc_k$(element_3);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = TextInput$_get_hint_$ref_uvwrja(element_3);
      var tmp_7 = getPropertyCallableRef('hint', 0, tmp_5, tmp_6, TextInput$_set_hint_$ref_i30g2i(element_3));
      element_3.invoke_bnq13k_k$(tmp_7, NewChildPlacementPage$render$slambda$lambda$lambda_1);
      element_3.bind_gesskf_k$(element_3.content_1, query);
      element_3.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_3);
      element_1.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_1);
      var results = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
        var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
        var tmp$ret$24 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        new (DataClassPathSelf())(tmp$ret$24);
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
        var tmp$ret$28 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it = new (DataClassPathSelf())(tmp$ret$28);
        var tmp$ret$25 = xDataClassPathContainsCased(get_name(it), $this$remember.invoke_r7m7el_k$(queryDebounced), true);
        var tmp$ret$21 = new (Query())(tmp$ret$25, orderBy, 0, 100);
        return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$21));
      });
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      element.willAddChild_hz2iwc_k$(element_4);
      element_4.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var tmp$ret$35 = weight(element_4, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_4 = get_scrolling(themed(sizeConstraints(tmp$ret$35, VOID, VOID, VOID, get_rem_0(20)), TableSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      this_4.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(true);
      var tmp_8 = get_centered(element_5);
      // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
      var this_5 = shownWhen(tmp_8, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(results).isEmpty_y1axqb_k$());
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_6 = themed(this_5, ForcePaddingSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (TextView())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_6.willAddChild_hz2iwc_k$(element_6);
      element_6.set_themeChoice_py59um_k$(element_6.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      var tmp_9 = KMutableProperty0();
      var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_6);
      var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_6));
      element_6.invoke_bnq13k_k$(tmp_11, NewChildPlacementPage$render$slambda$lambda$lambda_2);
      element_6.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_6);
      var tmp_12 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(results));
      colOf(element_5, tmp_12, VOID, VOID, VOID, ($this$colOf, loc) => {
        var tmp = themed($this$colOf, TableRowSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_0 = dynamicThemed(tmp, ($this$dynamicThemed) => equals($this$dynamicThemed.invoke_r7m7el_k$(this$0.locationLens_1), new (ID())($this$dynamicThemed.invoke_r7m7el_k$(loc)._id_1)) ? SelectedSemantic_getInstance() : None_instance);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Button())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element_0.willAddChild_hz2iwc_k$(element_1);
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(loc).name_1);
        element_1.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        onClick(element, VOID, VOID, VOID, NewChildPlacementPage$render$slambda$lambda$lambda$slambda(this$0, loc, close));
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      });
      element_5.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_5);
      element_4.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_4);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      element.willAddChild_hz2iwc_k$(element_7);
      element_7.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      element.willAddChild_hz2iwc_k$(element_8);
      element_8.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_7 = themed(element_8, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (Button())(this_7.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_7.willAddChild_hz2iwc_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (TextView())(element_9.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      element_9.willAddChild_hz2iwc_k$(element_10);
      var tmp_13 = KMutableProperty0();
      var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_10);
      var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_10));
      element_10.invoke_bnq13k_k$(tmp_15, NewChildPlacementPage$render$slambda$lambda$lambda_3);
      element_10.onStartup_vrxh3i_k$();
      element_9.addChild_2qpft2_k$(element_10);
      onClick(element_9, VOID, VOID, VOID, NewChildPlacementPage$render$slambda$lambda$slambda(close));
      element_9.onStartup_vrxh3i_k$();
      this_7.addChild_2qpft2_k$(element_9);
      element_8.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_8);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function NewChildPlacementPage$render$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementStartDateLabel_lvccn4_k$();
}
function NewChildPlacementPage$render$lambda_3(it) {
  return it.activeRange_1.start_1;
}
function NewChildPlacementPage$render$lambda_4(old, new_0) {
  return old.copy$default_164e4b_k$(VOID, VOID, VOID, VOID, old.activeRange_1.copy$default_iikz6e_k$(new_0 == null ? old.activeRange_1.start_1 : new_0));
}
function NewChildPlacementPage$render$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementEndDateLabel_oohsnt_k$();
}
function LocalDateField$_get_range_$ref_377gio(p0) {
  return constructCallableReference(() => p0.range_1, 0, 0, 197, VOID, [p0]);
}
function LocalDateField$_set_range_$ref_q3mzvw(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_range_xf733e_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 198, VOID, [p0]);
}
function NewChildPlacementPage$render$lambda_6(it) {
  return it.activeRange_1.endInclusive_1;
}
function NewChildPlacementPage$render$lambda_7(old, new_0) {
  return old.copy$default_164e4b_k$(VOID, VOID, VOID, VOID, old.activeRange_1.copy$default_iikz6e_k$(VOID, new_0));
}
function NewChildPlacementPage$render$slambda$slambda($max) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_164e4b_k$(VOID, VOID, VOID, VOID, it.activeRange_1.copy$default_iikz6e_k$(VOID, $max));
  }), 1);
}
function NewChildPlacementPage$render$slambda_0(this$0) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.placement_1;
    var end = (yield* await_0(this_0, $completion)).activeRange_1.endInclusive_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.maxEndDate_1;
    var max = (yield* await_0(this_1, $completion)).date_1;
    var tmp;
    if (end == null || end.compareTo_e7gwgq_k$(max) > 0) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_0();
      var tmp$ret$2 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      yield* delay(tmp$ret$2, $completion);
      tmp = yield* modify(this$0.placement_1, NewChildPlacementPage$render$slambda$slambda(max), $completion);
    }
    return Unit_instance;
  }), 1);
}
function NewChildPlacementPage$render$lambda_8($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementFundingHeading_tzzalb_k$();
}
function NewChildPlacementPage$render$lambda_9($this$multiSelectField) {
  return 'Paid by (employer authorizations)';
}
function NewChildPlacementPage$render$lambda_10($this$multiSelectField) {
  return 'Choose authorizations';
}
function NewChildPlacementPage$render$lambda_11(it) {
  return new (ID_1())(it.first_1._id_1);
}
function NewChildPlacementPage$render$lambda_12(it) {
  return it.second_1;
}
function NewChildPlacementPage$render$lambda_13($this$multiSelectField) {
  return "This family has no employer authorizations. Add one on the family's page.";
}
function NewChildPlacementPage$render$lambda_14($this$multiSelectField) {
  return $this$multiSelectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementPaidByGrantsLabel_y96mde_k$();
}
function NewChildPlacementPage$render$lambda_15($this$multiSelectField) {
  return $this$multiSelectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementChooseGrantsTitle_w90u32_k$();
}
function NewChildPlacementPage$render$lambda_16(it) {
  return new (ID_2())(it._id_1);
}
function NewChildPlacementPage$render$lambda_17(it) {
  return it.name_1;
}
function NewChildPlacementPage$render$lambda_18($this$multiSelectField, q) {
  var tmp = $this$multiSelectField.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = xDataClassPathContainsCased(get_name_0(it), $this$multiSelectField.invoke_r7m7el_k$(q), true);
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$multiSelectField.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function NewChildPlacementPage$render$lambda_19($this$multiSelectField, ids) {
  var tmp = $this$multiSelectField.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$();
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  new (DataClassPathSelf())(tmp$ret$3);
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$4 = xDataClassPathInsideSet(get__id(it), $this$multiSelectField.invoke_r7m7el_k$(ids));
  var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  return $this$multiSelectField.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
}
function NewChildPlacementPage$render$lambda_20($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childScheduleHeading_ybonig_k$();
}
function NewChildPlacementPage$render$lambda_21(it) {
  return it.schedule_1;
}
function NewChildPlacementPage$render$lambda_22(old, new_0) {
  return old.copy$default_164e4b_k$(VOID, new_0);
}
function NewChildPlacementPage$render$lambda_23(it) {
  var tmp = it == null ? null : it.program_1;
  return tmp == null ? null : new (ID_7())(tmp);
}
function NewChildPlacementPage$render$lambda_24(this$0, $schedule, $day) {
  return ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.invoke_r7m7el_k$(this$0.programsForChild_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = new (ID_7())(item._id_1);
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    var options = destination;
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(render$weekday($schedule, $day));
    var current = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.program_1;
    var tmp = listOf_0(null);
    var tmp_0;
    var tmp_1;
    var tmp_2 = current;
    if (!((tmp_2 == null ? null : new (ID_7())(tmp_2)) == null)) {
      tmp_1 = !options.contains_aljjnj_k$(new (ID_7())(current));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = plus_0(options, new (ID_7())(current));
    } else {
      tmp_0 = options;
    }
    return plus_1(tmp, tmp_0);
  };
}
function NewChildPlacementPage$render$lambda_25($schedule, $day) {
  return ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(render$weekday($schedule, $day)) == null);
}
function NewChildPlacementPage$render$lambda_26(this$0, $schedule, $day) {
  return ($this$shownWhen) => {
    var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(render$weekday($schedule, $day));
    var tmp1_safe_receiver = programNamed(this$0, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.program_1);
    return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.careTime_1, CareTime_FullTime_getInstance());
  };
}
function NewChildPlacementPage$render$lambda_27($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementWhenSchoolIsOutLabel_som316_k$();
}
function NewChildPlacementPage$render$lambda_28(it) {
  var tmp = it == null ? null : it.programWhenIntermittent_1;
  return tmp == null ? null : new (ID_7())(tmp);
}
function NewChildPlacementPage$render$lambda_29(old, new_0) {
  var tmp;
  if (old == null) {
    tmp = null;
  } else {
    var tmp_0 = new_0;
    tmp = old.copy$default_yokad6_k$(VOID, VOID, VOID, tmp_0 == null ? null : tmp_0.raw_1);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
function NewChildPlacementPage$render$lambda_30(this$0, $schedule, $day) {
  return ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(render$weekday($schedule, $day));
    var tmp1_safe_receiver = programNamed(this$0, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.program_1);
    var careTime = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.careTime_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.invoke_r7m7el_k$(this$0.programsForChild_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.availableAsIntermittent_1 && !element.careTime_1.equals(careTime)) {
        destination.add_utx5q5_k$(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$5 = new (ID_7())(item._id_1);
      destination_0.add_utx5q5_k$(tmp$ret$5);
    }
    var options = destination_0;
    var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(render$weekday($schedule, $day));
    var current = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.programWhenIntermittent_1;
    var tmp = listOf_0(null);
    var tmp_0;
    var tmp_1;
    var tmp_2 = current;
    if (!((tmp_2 == null ? null : new (ID_7())(tmp_2)) == null)) {
      tmp_1 = !options.contains_aljjnj_k$(new (ID_7())(current));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = plus_0(options, new (ID_7())(current));
    } else {
      tmp_0 = options;
    }
    return plus_1(tmp, tmp_0);
  };
}
function NewChildPlacementPage$render$lambda_31($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementTransportFromLabel_xf7eqr_k$();
}
function NewChildPlacementPage$render$lambda_32(it) {
  var tmp1_elvis_lhs = it == null ? null : it.transportFrom_1;
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function NewChildPlacementPage$render$lambda_33(old, new_0) {
  var tmp1_elvis_lhs = old == null ? null : old.copy$default_yokad6_k$(VOID, new_0);
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
function NewChildPlacementPage$render$lambda_34($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementTransportToLabel_ai59v0_k$();
}
function NewChildPlacementPage$render$lambda_35(it) {
  var tmp1_elvis_lhs = it == null ? null : it.transportTo_1;
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function NewChildPlacementPage$render$lambda_36(old, new_0) {
  var tmp1_elvis_lhs = old == null ? null : old.copy$default_yokad6_k$(VOID, VOID, new_0);
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
function NewChildPlacementPage$render$lambda_37($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function NewChildPlacementPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewChildPlacementPage$actionBar$slambda($$this$button, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!get_pageNavigator($$this$button.get_context_h02k06_k$()).goBack_kj7lzl_k$()) {
      get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (ChildDetailPage())(this$0.id_1));
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 0);
}
function NewChildPlacementPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudSaveButton_lsaoza_k$();
}
function NewChildPlacementPage$actionBar$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSendForSignatureTitle_fzt0kl_k$();
}
function NewChildPlacementPage$actionBar$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSendForSignatureBody_ualg6t_k$();
}
function NewChildPlacementPage$actionBar$slambda$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewChildPlacementPage$actionBar$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function NewChildPlacementPage$actionBar$slambda$lambda$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSaveAndSendButton_qp8w94_k$();
}
function NewChildPlacementPage$actionBar$slambda$lambda$slambda_0(this$0, $session, $location, $provider, $$this$button, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.copiedPlacement_1;
    var tmp0_safe_receiver = yield* await_0(this_0, $completion);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = this$0.placement_1;
      var tmp$ret$3 = yield* await_0(this_1, $completion);
      if (tmp0_safe_receiver.activeRange_1.overlaps_cm89fs_k$(tmp$ret$3.activeRange_1)) {
        var tmp = $session.get_childrenPlacement_hazabn_k$().get_6ueaa7_k$(new (ID_3())(tmp0_safe_receiver._id_1));
        // Inline function 'com.lightningkite.services.database.modification' call
        // Inline function 'kotlin.apply' call
        var this_2 = new (ModificationBuilder())();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
        var tmp$ret$8 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$8);
        var tmp_1 = get_activeRange(it);
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_3 = this$0.placement_1;
        var tmp$ret$10 = yield* await_0(this_3, $completion);
        this_2.assign_vtsfu6_k$(tmp_1, tmp0_safe_receiver.activeRange_1.copy$default_iikz6e_k$(VOID, minus(tmp$ret$10.activeRange_1.start_1, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 1))));
        var tmp$ret$4 = this_2.build_1k0s4u_k$();
        yield* tmp.modify_ff53f_k$(tmp$ret$4, $completion);
      }
    }
    var saved = yield* this$0.placement_1.publish_xq9q2e_k$($completion);
    var tmp_2 = $session.get_childrenPlacement_hazabn_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = this$0.child_1;
    var tmp_3 = (yield* await_0(this_4, $completion)).get_fullName_9skygt_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = this$0.child_1;
    var tmp_4 = (yield* await_0(this_5, $completion)).birthDate_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = this$0.child_1;
    var tmp$ret$13 = yield* await_0(this_6, $completion);
    yield* tmp_2.add_co22jy_k$(new (ChildPlacement())(VOID, this$0.id_1, tmp_3, tmp_4, tmp$ret$13.family_1, $location._id_1, $provider._id_1, saved.authorizations_1, VOID, saved.grants_1, saved.schedule_1, saved.activeRange_1), $completion);
    var tmp_5 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_7 = get_strings(AppState_getInstance());
    var tmp$ret$14 = yield* await_1(this_7, $completion);
    toast(tmp_5, tmp$ret$14.get_placementAddedToast_9n8dct_k$());
    $close();
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (ChildDetailPage())(this$0.id_1));
    return Unit_instance;
  }), 1);
}
function NewChildPlacementPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.placement_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_issues(this$0.placement_1);
      var tmp$ret$2 = yield* await_0(this_1, $completion);
      println('ISSUES: ' + toString_0(tmp$ret$2));
      return Unit_instance;
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var session = yield* await_0(this_2, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.placement_1;
    var tmp0_safe_receiver = (yield* await_0(this_3, $completion)).location_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      var tmp_2 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_2 == null ? null : new (ID())(tmp_2)).raw_1;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_4 = session.get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID())(it));
      tmp_0 = yield* await_0(this_4, $completion);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var location = tmp_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = session.get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_4())(location.provider_1));
    var tmp2_elvis_lhs = yield* await_0(this_5, $completion);
    var tmp_4;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_4 = tmp2_elvis_lhs;
    }
    var provider = tmp_4;
    var tmp_5;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = this$0.issues_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_6, $completion)).isEmpty_y1axqb_k$()) {
      return Unit_instance;
    }
    var tmp_6 = $$this$button.get_context_h02k06_k$();
    dialog(tmp_6, VOID, ($this$dialog, close) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, NewChildPlacementPage$actionBar$slambda$lambda$lambda);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
      var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
        var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(this$0.copiedPlacement_1);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.activeRange_1;
        return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.overlaps_cm89fs_k$($this$shownWhen.invoke_r7m7el_k$(this$0.placement_1).activeRange_1)) === true;
      });
      // Inline function 'com.lightningkite.kiteui.views.warning' call
      var this_2 = themed(this_1, BannerSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_3 = themed(this_2, WarningSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_3.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      element_1.willAddChild_hz2iwc_k$(element_2);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
        var newStart = $this$invoke.invoke_r7m7el_k$(this$0.placement_1).activeRange_1.start_1;
        var cutoffDate = minus(newStart, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 1));
        var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this$0.copiedPlacement_1);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.activeRange_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.endInclusive_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : renderToString(tmp2_safe_receiver, RenderSize_Abbreviation_getInstance());
        var previousEnd = tmp3_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_childNoEndDateLabel_vluxrz_k$() : tmp3_elvis_lhs;
        return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).placementPreviousEndChangeMessage_u9z0qq_k$(previousEnd, renderToString(cutoffDate, RenderSize_Abbreviation_getInstance()), renderToString(newStart, RenderSize_Abbreviation_getInstance()));
      });
      element_2.onStartup_vrxh3i_k$();
      element_1.addChild_2qpft2_k$(element_2);
      element_1.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element.willAddChild_hz2iwc_k$(element_3);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_3);
      var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_3));
      element_3.invoke_bnq13k_k$(tmp_7, NewChildPlacementPage$actionBar$slambda$lambda$lambda_0);
      element_3.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      element.willAddChild_hz2iwc_k$(element_4);
      element_4.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_4);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      element.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_4 = themed(element_5, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (Button())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_4.willAddChild_hz2iwc_k$(element_6);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      element_6.willAddChild_hz2iwc_k$(element_7);
      var tmp_8 = KMutableProperty0();
      var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_7);
      var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_7));
      element_7.invoke_bnq13k_k$(tmp_10, NewChildPlacementPage$actionBar$slambda$lambda$lambda_1);
      element_7.onStartup_vrxh3i_k$();
      element_6.addChild_2qpft2_k$(element_7);
      onClick(element_6, VOID, VOID, VOID, NewChildPlacementPage$actionBar$slambda$lambda$slambda(close));
      element_6.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_6);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_5 = weight(element_5, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (Space())(this_5.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      this_5.willAddChild_hz2iwc_k$(element_8);
      element_8.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_8);
      // Inline function 'com.lightningkite.kiteui.views.important' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_6 = themed(element_5, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_7 = themed(this_6, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (Button())(this_7.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_7.willAddChild_hz2iwc_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (TextView())(element_9.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      element_9.willAddChild_hz2iwc_k$(element_10);
      var tmp_11 = KMutableProperty0();
      var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_10);
      var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_10));
      element_10.invoke_bnq13k_k$(tmp_13, NewChildPlacementPage$actionBar$slambda$lambda$lambda_2);
      element_10.onStartup_vrxh3i_k$();
      element_9.addChild_2qpft2_k$(element_10);
      element_9.set_action_2ds022_k$(Action('Add placement', VOID, VOID, VOID, VOID, VOID, NewChildPlacementPage$actionBar$slambda$lambda$slambda_0(this$0, session, location, provider, element_9, close)));
      element_9.onStartup_vrxh3i_k$();
      this_7.addChild_2qpft2_k$(element_9);
      element_5.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_5);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
var NewChildPlacementPageClass;
function NewChildPlacementPage() {
  if (NewChildPlacementPageClass === VOID) {
    class $ extends Form() {
      constructor(id, copied) {
        copied = copied === VOID ? null : copied;
        super();
        this.id_1 = id;
        this.copied_1 = copied;
        var tmp = this;
        tmp.child_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_children_4cwbp4_k$().get_6ueaa7_k$(new (ID_5())(this.id_1))));
        var tmp_0 = this;
        tmp_0.copiedPlacement_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          var tmp_0 = this.copied_1;
          if (!((tmp_0 == null ? null : new (ID_3())(tmp_0)) == null)) {
            tmp = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$().get_6ueaa7_k$(new (ID_3())(this.copied_1)));
          } else {
            tmp = null;
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.familyAuthorizations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyEmployerAuthorizations_srfp8e_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = eq(get_family(it), new (ID_6())($this$remember.invoke_r7m7el_k$(this.child_1).family_1));
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          // Inline function 'kotlin.collections.sortedByDescending' call
          var this_0 = $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp_2 = NewChildPlacementPage$familyAuthorizations$lambda$lambda;
          var tmp$ret$11 = new (sam$kotlin_Comparator$0())(tmp_2);
          return sortedWith(this_0, tmp$ret$11);
        });
        var tmp_2 = this;
        tmp_2.placement_1 = validated(Draft(($this$Draft) => {
          var copied = $this$Draft.invoke_r7m7el_k$(this.copiedPlacement_1);
          var tmp;
          if (!(copied == null)) {
            var tmp0_safe_receiver = copied.activeRange_1.endInclusive_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : plus(tmp0_safe_receiver, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 1));
            tmp = tmp1_elvis_lhs == null ? today() : tmp1_elvis_lhs;
          } else {
            tmp = nowLocal().get_date_wokkxj_k$();
          }
          var start = tmp;
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$Draft.invoke_r7m7el_k$(this.familyAuthorizations_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.activeRange_1.contains_3tkdvy_k$(start)) {
              destination.add_utx5q5_k$(element);
            }
          }
          var covering = destination;
          var tmp_0 = copied == null ? null : copied.location_1;
          var tmp4_elvis_lhs = copied == null ? null : copied.schedule_1;
          var tmp_1 = tmp4_elvis_lhs == null ? new (Schedule())() : tmp4_elvis_lhs;
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(covering, 10));
          var _iterator__ex2g4s_0 = covering.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp$ret$17 = new (ID_1())(item._id_1);
            destination_0.add_utx5q5_k$(tmp$ret$17);
          }
          var tmp_2 = toSet(destination_0);
          var tmp6_elvis_lhs = copied == null ? null : copied.grants_1;
          var tmp_3;
          if (tmp6_elvis_lhs == null) {
            // Inline function 'kotlin.collections.setOf' call
            tmp_3 = emptySet();
          } else {
            tmp_3 = tmp6_elvis_lhs;
          }
          var tmp_4 = tmp_3;
          var tmp$ret$19;
          $l$block: {
            // Inline function 'kotlin.collections.maxOfOrNull' call
            var iterator = covering.iterator_jk1svi_k$();
            if (!iterator.hasNext_bitz1p_k$()) {
              tmp$ret$19 = null;
              break $l$block;
            }
            var maxValue = iterator.next_20eer_k$().activeRange_1.endInclusive_1;
            while (iterator.hasNext_bitz1p_k$()) {
              var v = iterator.next_20eer_k$().activeRange_1.endInclusive_1;
              if (compareTo(maxValue, v) < 0) {
                maxValue = v;
              }
            }
            tmp$ret$19 = maxValue;
          }
          return new (NewPlacementDraft())(tmp_0, tmp_1, tmp_2, tmp_4, new (LocalDateRange())(start, tmp$ret$19));
        }));
        var tmp_3 = this;
        tmp_3.selectedLocation_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.locationLens_1);
          var tmp0_elvis_lhs = tmp == null ? null : tmp.raw_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
            return null;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var locationId = tmp_0;
          return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID())(locationId)));
        });
        var tmp_4 = this;
        tmp_4.selectedProvider_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(this.selectedLocation_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.provider_1;
          var tmp;
          var tmp_0 = tmp1_elvis_lhs;
          if ((tmp_0 == null ? null : new (ID_4())(tmp_0)) == null) {
            return null;
          } else {
            tmp = tmp1_elvis_lhs;
          }
          var providerId = tmp;
          return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_4())(providerId)));
        });
        var tmp_5 = this;
        tmp_5.locationPrograms_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.locationLens_1);
          var tmp0_elvis_lhs = tmp == null ? null : tmp.raw_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
            // Inline function 'kotlin.collections.listOf' call
            return emptyList();
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var locationId = tmp_0;
          var tmp_2 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
          var tmp$ret$26 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$26);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
          var tmp$ret$30 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$30);
          var tmp$ret$27 = eq(get_location(it), new (ID())(locationId));
          var tmp$ret$23 = new (Query())(tmp$ret$27, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp_2.query_so6xq1_k$(tmp$ret$23));
        });
        var tmp_6 = this;
        tmp_6.programsForChild_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.invoke_r7m7el_k$(this.locationPrograms_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (fitsChild(this, $this$remember, element)) {
              destination.add_utx5q5_k$(element);
            }
          }
          return destination;
        });
        this.addEndDate_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        var tmp_7 = this;
        var tmp_8 = NewChildPlacementPage$locationLens$lambda;
        tmp_7.locationLens_1 = this.placement_1.lens_u4wb4z_k$(tmp_8, NewChildPlacementPage$locationLens$lambda_0);
        var tmp_9 = this;
        var tmp_10 = NewChildPlacementPage$authorizationsLens$lambda;
        tmp_9.authorizationsLens_1 = this.placement_1.lens_u4wb4z_k$(tmp_10, NewChildPlacementPage$authorizationsLens$lambda_0);
        var tmp_11 = this;
        tmp_11.authorizationOptions_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$39 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$39);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$43 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$43);
          var tmp_2 = get__id_0(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.familyAuthorizations_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$48 = new (ID_0())(item.employer_1);
            destination.add_utx5q5_k$(tmp$ret$48);
          }
          var tmp$ret$40 = xDataClassPathInsideSet(tmp_2, toSet(destination));
          var tmp$ret$36 = new (Query())(tmp$ret$40, orderBy, 0, 100);
          var employers = $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$36));
          // Inline function 'kotlin.collections.map' call
          var this_1 = $this$remember.invoke_r7m7el_k$(this.familyAuthorizations_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$53;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_1 = employers.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s_1.next_20eer_k$();
                if (equals(element._id_1, item_0.employer_1)) {
                  tmp$ret$53 = element;
                  break $l$block_0;
                }
              }
              tmp$ret$53 = null;
            }
            var tmp0_safe_receiver = tmp$ret$53;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
            var employer = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            var start = renderToString(item_0.activeRange_1.start_1, RenderSize_Abbreviation_getInstance());
            var end = renderToString(item_0.activeRange_1.endInclusive_1, RenderSize_Abbreviation_getInstance());
            var tmp$ret$51 = to(item_0, employer + ' \xB7 ' + start + ' \u2013 ' + end);
            destination_0.add_utx5q5_k$(tmp$ret$51);
          }
          return destination_0;
        });
        var tmp_12 = this;
        var tmp_13 = NewChildPlacementPage$grantsLens$lambda;
        tmp_12.grantsLens_1 = this.placement_1.lens_u4wb4z_k$(tmp_13, NewChildPlacementPage$grantsLens$lambda_0);
        var tmp_14 = this;
        tmp_14.maxEndDate_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.placement_1).schedule_1.get_programs_mo5naw_k$();
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var p = item.raw_1;
            // Inline function 'kotlin.collections.find' call
            var tmp0 = $this$remember.invoke_r7m7el_k$(this.programsForChild_1);
            var tmp$ret$59;
            $l$block_1: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s_0.next_20eer_k$();
                if (equals(element._id_1, p)) {
                  tmp$ret$59 = element;
                  break $l$block_1;
                }
              }
              tmp$ret$59 = null;
            }
            var tmp$ret$57 = tmp$ret$59;
            destination.add_utx5q5_k$(tmp$ret$57);
          }
          var programs = destination;
          // Inline function 'kotlin.collections.map' call
          var this_1 = $this$remember.invoke_r7m7el_k$(this.placement_1).authorizations_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_1 = this_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
            var p_0 = item_0.raw_1;
            // Inline function 'kotlin.collections.find' call
            var tmp0_0 = $this$remember.invoke_r7m7el_k$(this.authorizationOptions_1);
            var tmp$ret$65;
            $l$block_2: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_2 = tmp0_0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
                var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
                if (equals(element_0.first_1._id_1, p_0)) {
                  tmp$ret$65 = element_0;
                  break $l$block_2;
                }
              }
              tmp$ret$65 = null;
            }
            var tmp$ret$63 = tmp$ret$65;
            destination_0.add_utx5q5_k$(tmp$ret$63);
          }
          var authorizations = destination_0;
          var birthDate = $this$remember.invoke_r7m7el_k$(this.child_1).birthDate_1;
          var tmp = filterNotNull(asSequence(programs));
          var tmp_0 = mapNotNull(tmp, (it) => {
            var tmp0_safe_receiver = it.ageEndInclusive_1;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp = plus(birthDate, tmp0_safe_receiver);
            }
            var tmp1_elvis_lhs = tmp;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            return new (MaxEndDate())(tmp_0, it);
          });
          var tmp_1 = filterNotNull(asSequence(authorizations));
          var tmp0_1 = flatten_0(sequenceOf_0([tmp_0, mapNotNull(tmp_1, NewChildPlacementPage$maxEndDate$lambda$lambda), sequenceOf(new (MaxEndDate())(plus($this$remember.invoke_r7m7el_k$(this.child_1).birthDate_1, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(18))))]));
          var tmp$ret$69;
          $l$block_3: {
            // Inline function 'kotlin.sequences.minBy' call
            var iterator = tmp0_1.iterator_jk1svi_k$();
            if (!iterator.hasNext_bitz1p_k$())
              throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
            var minElem = iterator.next_20eer_k$();
            if (!iterator.hasNext_bitz1p_k$()) {
              tmp$ret$69 = minElem;
              break $l$block_3;
            }
            var minValue = minElem.date_1;
            do {
              var e = iterator.next_20eer_k$();
              var v = e.date_1;
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.hasNext_bitz1p_k$());
            tmp$ret$69 = minElem;
          }
          return tmp$ret$69;
        });
        var tmp_15 = this;
        tmp_15.issues_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = get_entries();
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(this.placement_1).schedule_1.get_riprg6_k$(element);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.add_utx5q5_k$(tmp0_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp = element_0.programWhenIntermittent_1;
            var list = listOfNotNull([new (ID_7())(element_0.program_1), tmp == null ? null : new (ID_7())(tmp)]);
            addAll(destination_0, list);
          }
          var chosen = destination_0;
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = $this$remember.invoke_r7m7el_k$(this.locationPrograms_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
            if (chosen.contains_aljjnj_k$(new (ID_7())(element_1._id_1))) {
              destination_1.add_utx5q5_k$(element_1);
            }
          }
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_2 = destination_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
            var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
            var placementRange = $this$remember.invoke_r7m7el_k$(this.placement_1).activeRange_1;
            var tmp0_elvis_lhs = placementRange.endInclusive_1;
            var placementEnd = tmp0_elvis_lhs == null ? LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(3000, 1, 1) : tmp0_elvis_lhs;
            var birthDate = $this$remember.invoke_r7m7el_k$(this.child_1).birthDate_1;
            var tmp1_safe_receiver = element_2.ageStart_1;
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = placementRange.start_1.compareTo_e7gwgq_k$(plus(birthDate, tmp1_safe_receiver)) >= 0;
            }
            var tmp2_elvis_lhs = tmp_0;
            var oldEnough = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
            var tmp3_safe_receiver = element_2.ageEndInclusive_1;
            var tmp_1;
            if (tmp3_safe_receiver == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_1 = placementEnd.compareTo_e7gwgq_k$(plus(birthDate, tmp3_safe_receiver)) <= 0;
            }
            var tmp4_elvis_lhs = tmp_1;
            var youngEnough = tmp4_elvis_lhs == null ? true : tmp4_elvis_lhs;
            var tmp_2;
            if (!oldEnough) {
              var tmp5_safe_receiver = element_2.ageStart_1;
              var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : renderToString_0(tmp5_safe_receiver);
              tmp_2 = 'Child must be at least ' + (tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs) + ' old for ' + element_2.name_1 + ', but on the start date (' + renderToString(placementRange.start_1, RenderSize_Abbreviation_getInstance()) + ") they aren't old enough.";
            } else if (!youngEnough) {
              var tmp7_safe_receiver = element_2.ageStart_1;
              var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : renderToString_0(tmp7_safe_receiver);
              tmp_2 = 'Child must be younger than ' + (tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs) + ' old for ' + element_2.name_1 + ', but by the end date (' + renderToString(placementEnd, RenderSize_Abbreviation_getInstance()) + ") they've aged out.";
            } else {
              tmp_2 = null;
            }
            var tmp0_safe_receiver_0 = tmp_2;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_2.add_utx5q5_k$(tmp0_safe_receiver_0);
            }
          }
          var tmp_3 = destination_2;
          // Inline function 'kotlin.collections.filter' call
          var tmp0_1 = $this$remember.invoke_r7m7el_k$(this.familyAuthorizations_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_3 = tmp0_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
            var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
            if ($this$remember.invoke_r7m7el_k$(this.placement_1).authorizations_1.contains_aljjnj_k$(new (ID_1())(element_3._id_1))) {
              destination_3.add_utx5q5_k$(element_3);
            }
          }
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_4 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_4 = destination_3.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
            var element_4 = _iterator__ex2g4s_4.next_20eer_k$();
            var placementRange_0 = $this$remember.invoke_r7m7el_k$(this.placement_1).activeRange_1;
            var tmp0_elvis_lhs_0 = placementRange_0.endInclusive_1;
            var placementEnd_0 = tmp0_elvis_lhs_0 == null ? LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(3000, 1, 1) : tmp0_elvis_lhs_0;
            var required = element_4.activeRange_1;
            var tmp0_safe_receiver_1 = required.endInclusive_1.compareTo_e7gwgq_k$(placementEnd_0) < 0 ? 'Authorization from ' + invoke$name(element_4.employer_1, $this$remember) + ' ends on ' + renderToString(required.endInclusive_1, RenderSize_Abbreviation_getInstance()) + ', before the end date ' + renderToString(placementEnd_0, RenderSize_Abbreviation_getInstance()) + '.' : required.start_1.compareTo_e7gwgq_k$(placementRange_0.start_1) > 0 ? 'Authorization from ' + invoke$name(element_4.employer_1, $this$remember) + ' starts on ' + renderToString(required.start_1, RenderSize_Abbreviation_getInstance()) + ', after the start date ' + renderToString(placementRange_0.start_1, RenderSize_Abbreviation_getInstance()) + '.' : null;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_4.add_utx5q5_k$(tmp0_safe_receiver_1);
            }
          }
          return flatten(listOf([tmp_3, destination_4]));
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, NewChildPlacementPage$_get_title_$lambda_rvokn2);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.placement_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).placementAddForChildTitle_tfmgtt_k$($this$invoke.invoke_r7m7el_k$(this.child_1).get_fullName_9skygt_k$()));
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_2.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_4, NewChildPlacementPage$render$lambda);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_2.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_3 = weight(element_4, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_3.willAddChild_hz2iwc_k$(element_5);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = LabeledView$_get_content_$ref_5yojet(element_5);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, LabeledView$_set_content_$ref_ys1c8f(element_5));
        element_5.invoke_bnq13k_k$(tmp_7, NewChildPlacementPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var this_4 = themed(element_5, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_5 = themed(this_4, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Button())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_5.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_6 = get_centered(element_7);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (IconView())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_6.willAddChild_hz2iwc_k$(element_8);
        element_8.set_source_3o5lkf_k$(Companion_getInstance_1().search_1.resize_q1xpz0_k$(get_rem(1.25)));
        var tmp_8 = KMutableProperty0();
        var tmp_9 = IconView$_get_description_$ref_x7iif6(element_8);
        var tmp_10 = getPropertyCallableRef('description', 0, tmp_8, tmp_9, IconView$_set_description_$ref_rpvc1e(element_8));
        element_8.invoke_bnq13k_k$(tmp_10, NewChildPlacementPage$render$lambda_1);
        element_8.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_7 = get_centered(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_8 = weight(this_7, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_8.willAddChild_hz2iwc_k$(element_9);
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_13, ($this$invoke) => {
          var loc = $this$invoke.invoke_r7m7el_k$(this.selectedLocation_1);
          var tmp;
          if (!(loc == null)) {
            var tmp_0 = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.selectedProvider_1);
            tmp = tmp_0.placementLocationWithProvider_dft4wy_k$(loc.name_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1);
          } else {
            tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSelectCareLocationPlaceholder_zi5v79_k$();
          }
          return tmp;
        });
        element_9.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_9);
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        onClick(element_6, VOID, VOID, VOID, NewChildPlacementPage$render$slambda(element_6, this));
        element_6.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_6);
        errorText(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_5);
        element_4.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_rem_0(50);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowCollapsingToColumn())(element_2.get_context_h02k06_k$(), listOf_0(new (Dimension())(breakpoint)));
        ensureOutermostElement(element_10);
        element_2.willAddChild_hz2iwc_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_9 = weight(element_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_9.willAddChild_hz2iwc_k$(element_11);
        var tmp_14 = KMutableProperty0();
        var tmp_15 = LabeledView$_get_content_$ref_5yojet(element_11);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, LabeledView$_set_content_$ref_ys1c8f(element_11));
        element_11.invoke_bnq13k_k$(tmp_16, NewChildPlacementPage$render$lambda_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_10 = themed(element_11, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (LocalDateField())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_10.willAddChild_hz2iwc_k$(element_12);
        var tmp_17 = NewChildPlacementPage$render$lambda_3;
        element_12.bind_gesskf_k$(element_12.content_1, this.placement_1.lens_u4wb4z_k$(tmp_17, NewChildPlacementPage$render$lambda_4));
        element_12.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_12);
        errorText(element_11);
        element_11.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_11 = weight(element_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_11.willAddChild_hz2iwc_k$(element_13);
        var tmp_18 = KMutableProperty0();
        var tmp_19 = LabeledView$_get_content_$ref_5yojet(element_13);
        var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, LabeledView$_set_content_$ref_ys1c8f(element_13));
        element_13.invoke_bnq13k_k$(tmp_20, NewChildPlacementPage$render$lambda_5);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_12 = themed(element_13, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (LocalDateField())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_12.willAddChild_hz2iwc_k$(element_14);
        var tmp_21 = KMutableProperty0();
        var tmp_22 = LocalDateField$_get_range_$ref_377gio(element_14);
        var tmp_23 = getPropertyCallableRef('range', 0, tmp_21, tmp_22, LocalDateField$_set_range_$ref_q3mzvw(element_14));
        element_14.invoke_bnq13k_k$(tmp_23, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.placement_1).activeRange_1.start_1.rangeTo_fqdtz2_k$($this$invoke.invoke_r7m7el_k$(this.maxEndDate_1).date_1));
        var tmp_24 = NewChildPlacementPage$render$lambda_6;
        element_14.bind_gesskf_k$(element_14.content_1, this.placement_1.lens_u4wb4z_k$(tmp_24, NewChildPlacementPage$render$lambda_7));
        reactiveSuspending(element_14, NewChildPlacementPage$render$slambda_0(this));
        element_14.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_14);
        errorText(element_13);
        element_13.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_13);
        element_10.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (TextView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_2.willAddChild_hz2iwc_k$(element_15);
        element_15.set_themeChoice_py59um_k$(element_15.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_25 = KMutableProperty0();
        var tmp_26 = TextView$_get_content_$ref_4pzcwl(element_15);
        var tmp_27 = getPropertyCallableRef('content', 0, tmp_25, tmp_26, TextView$_set_content_$ref_pketfb(element_15));
        element_15.invoke_bnq13k_k$(tmp_27, ($this$invoke) => {
          var m = $this$invoke.invoke_r7m7el_k$(this.maxEndDate_1);
          var tmp0_safe_receiver = m.program_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_0 = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
            var tmp0_elvis_lhs = tmp0_safe_receiver.ageEndInclusive_1;
            tmp = 'child ages out of ' + tmp0_safe_receiver.name_1 + ' (max age: ' + tmp_0.yearMonthDay_bm7hs7_k$(tmp0_elvis_lhs == null ? DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 0) : tmp0_elvis_lhs) + ')';
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            var tmp_2;
            if (m.authorization_1 == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_2 = 'authorization expires';
            }
            tmp_1 = tmp_2;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp_1;
          var reason = tmp3_elvis_lhs == null ? 'child turns 18' : tmp3_elvis_lhs;
          return 'Maximum end date is ' + renderToString(m.date_1) + ' because ' + reason;
        });
        element_15.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_15);
        element_2.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_13.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (TextView())(element_16.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element_16.willAddChild_hz2iwc_k$(element_17);
        element_17.set_themeChoice_py59um_k$(element_17.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_28 = KMutableProperty0();
        var tmp_29 = TextView$_get_content_$ref_4pzcwl(element_17);
        var tmp_30 = getPropertyCallableRef('content', 0, tmp_28, tmp_29, TextView$_set_content_$ref_pketfb(element_17));
        element_17.invoke_bnq13k_k$(tmp_30, NewChildPlacementPage$render$lambda_8);
        element_17.onStartup_vrxh3i_k$();
        element_16.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(element_16.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        element_16.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(false);
        var tmp_31 = NewChildPlacementPage$render$lambda_9;
        var tmp_32 = NewChildPlacementPage$render$lambda_10;
        var tmp_33 = NewChildPlacementPage$render$lambda_11;
        var tmp_34 = NewChildPlacementPage$render$lambda_12;
        var tmp_35 = ($this$multiSelectField, q) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$multiSelectField.invoke_r7m7el_k$(this.authorizationOptions_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (contains(element.second_1, $this$multiSelectField.invoke_r7m7el_k$(q), true)) {
              destination.add_utx5q5_k$(element);
            }
          }
          return destination;
        };
        var tmp_36 = ($this$multiSelectField, ids) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$multiSelectField.invoke_r7m7el_k$(this.authorizationOptions_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if ($this$multiSelectField.invoke_r7m7el_k$(ids).contains_aljjnj_k$(new (ID_1())(element.first_1._id_1))) {
              destination.add_utx5q5_k$(element);
            }
          }
          return destination;
        };
        multiSelectField(element_18, tmp_31, tmp_32, this.authorizationsLens_1, tmp_33, tmp_34, tmp_35, tmp_36, VOID, VOID, NewChildPlacementPage$render$lambda_13);
        var tmp_37 = NewChildPlacementPage$render$lambda_14;
        var tmp_38 = NewChildPlacementPage$render$lambda_15;
        var tmp_39 = NewChildPlacementPage$render$lambda_16;
        var tmp_40 = NewChildPlacementPage$render$lambda_17;
        var tmp_41 = NewChildPlacementPage$render$lambda_18;
        multiSelectField(element_18, tmp_37, tmp_38, this.grantsLens_1, tmp_39, tmp_40, tmp_41, NewChildPlacementPage$render$lambda_19);
        element_18.onStartup_vrxh3i_k$();
        element_16.addChild_2qpft2_k$(element_18);
        element_16.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_16);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        this_14.willAddChild_hz2iwc_k$(element_19);
        element_19.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (TextView())(element_19.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        element_19.willAddChild_hz2iwc_k$(element_20);
        element_20.set_themeChoice_py59um_k$(element_20.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_42 = KMutableProperty0();
        var tmp_43 = TextView$_get_content_$ref_4pzcwl(element_20);
        var tmp_44 = getPropertyCallableRef('content', 0, tmp_42, tmp_43, TextView$_set_content_$ref_pketfb(element_20));
        element_20.invoke_bnq13k_k$(tmp_44, NewChildPlacementPage$render$lambda_20);
        element_20.onStartup_vrxh3i_k$();
        element_19.addChild_2qpft2_k$(element_20);
        var tmp_45 = NewChildPlacementPage$render$lambda_21;
        var schedule = this.placement_1.lens_u4wb4z_k$(tmp_45, NewChildPlacementPage$render$lambda_22);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_15 = get_scrollingHorizontally(element_19);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        this_15.willAddChild_hz2iwc_k$(element_21);
        element_21.set_vertical_nuap32_k$(false);
        var _iterator__ex2g4s = listOf([DayOfWeek_SUNDAY_getInstance(), DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance()]).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var day = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_16 = themed(element_21, ShadedSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_17 = themed(this_16, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_22 = new (RowOrCol())(this_17.get_context_h02k06_k$());
          ensureOutermostElement(element_22);
          this_17.willAddChild_hz2iwc_k$(element_22);
          element_22.set_vertical_nuap32_k$(true);
          var tmp_46 = get_bold(element_22);
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$115 = day.name_1.toLowerCase();
          text(tmp_46, titleCase(tmp$ret$115));
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_18 = themed(element_22, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_23 = new (Select())(this_18.get_context_h02k06_k$());
          ensureOutermostElement(element_23);
          this_18.willAddChild_hz2iwc_k$(element_23);
          var tmp_47 = render$weekday(schedule, day);
          var tmp_48 = NewChildPlacementPage$render$lambda_23;
          var tmp_49 = tmp_47.lens_u4wb4z_k$(tmp_48, (old, new_0) => {
            var tmp;
            if (new_0 == null) {
              tmp = null;
            } else {
              if (old == null) {
                tmp = new (Day())(new_0.raw_1);
              } else {
                var tmp_0 = new_0;
                var tmp0_safe_receiver = programNamed(this, tmp_0 == null ? null : tmp_0.raw_1);
                if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.careTime_1, CareTime_FullTime_getInstance())) {
                  tmp = old.copy$default_yokad6_k$(new_0.raw_1, VOID, VOID, null);
                } else {
                  tmp = old.copy$default_yokad6_k$(new_0.raw_1);
                }
              }
            }
            return tmp;
          });
          var tmp_50 = remember(VOID, VOID, VOID, VOID, NewChildPlacementPage$render$lambda_24(this, schedule, day));
          element_23.bind_64a41i_k$(tmp_49, tmp_50, (id) => {
            var tmp = id;
            var tmp0_safe_receiver = programNamed(this, tmp == null ? null : tmp.raw_1);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              var tmp2_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
              tmp_0 = (tmp2_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp2_elvis_lhs).get_childNotScheduledLabel_mg5553_k$();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            return tmp_0;
          });
          element_23.onStartup_vrxh3i_k$();
          this_18.addChild_2qpft2_k$(element_23);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_19 = shownWhen(element_22, VOID, VOID, NewChildPlacementPage$render$lambda_25(schedule, day));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_24 = new (RowOrCol())(this_19.get_context_h02k06_k$());
          ensureOutermostElement(element_24);
          this_19.willAddChild_hz2iwc_k$(element_24);
          element_24.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_25 = new (Separator())(element_24.get_context_h02k06_k$());
          ensureOutermostElement(element_25);
          element_24.willAddChild_hz2iwc_k$(element_25);
          element_25.onStartup_vrxh3i_k$();
          element_24.addChild_2qpft2_k$(element_25);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var this_20 = shownWhen(element_24, VOID, VOID, NewChildPlacementPage$render$lambda_26(this, schedule, day));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_26 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_20.get_context_h02k06_k$());
          ensureOutermostElement(element_26);
          this_20.willAddChild_hz2iwc_k$(element_26);
          var tmp_51 = KMutableProperty0();
          var tmp_52 = LabeledView$_get_content_$ref_5yojet(element_26);
          var tmp_53 = getPropertyCallableRef('content', 0, tmp_51, tmp_52, LabeledView$_set_content_$ref_ys1c8f(element_26));
          element_26.invoke_bnq13k_k$(tmp_53, NewChildPlacementPage$render$lambda_27);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_21 = themed(element_26, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_27 = new (Select())(this_21.get_context_h02k06_k$());
          ensureOutermostElement(element_27);
          this_21.willAddChild_hz2iwc_k$(element_27);
          var tmp_54 = render$weekday(schedule, day);
          var tmp_55 = NewChildPlacementPage$render$lambda_28;
          var tmp_56 = tmp_54.lens_u4wb4z_k$(tmp_55, NewChildPlacementPage$render$lambda_29);
          var tmp_57 = remember(VOID, VOID, VOID, VOID, NewChildPlacementPage$render$lambda_30(this, schedule, day));
          element_27.bind_64a41i_k$(tmp_56, tmp_57, (id) => {
            var tmp = id;
            var tmp0_safe_receiver = programNamed(this, tmp == null ? null : tmp.raw_1);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              var tmp2_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
              tmp_0 = (tmp2_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp2_elvis_lhs).get_placementNotIntermittentLabel_4hk03a_k$();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            return tmp_0;
          });
          element_27.onStartup_vrxh3i_k$();
          this_21.addChild_2qpft2_k$(element_27);
          errorText(element_26);
          element_26.onStartup_vrxh3i_k$();
          this_20.addChild_2qpft2_k$(element_26);
          var tmp_58 = NewChildPlacementPage$render$lambda_31;
          var tmp_59 = render$weekday(schedule, day);
          var tmp_60 = NewChildPlacementPage$render$lambda_32;
          labeledCheckbox(element_24, tmp_58, tmp_59.lens_u4wb4z_k$(tmp_60, NewChildPlacementPage$render$lambda_33));
          var tmp_61 = NewChildPlacementPage$render$lambda_34;
          var tmp_62 = render$weekday(schedule, day);
          var tmp_63 = NewChildPlacementPage$render$lambda_35;
          labeledCheckbox(element_24, tmp_61, tmp_62.lens_u4wb4z_k$(tmp_63, NewChildPlacementPage$render$lambda_36));
          element_24.onStartup_vrxh3i_k$();
          this_19.addChild_2qpft2_k$(element_24);
          element_22.onStartup_vrxh3i_k$();
          this_17.addChild_2qpft2_k$(element_22);
        }
        element_21.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_21);
        element_19.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_19);
        // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
        var this_22 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(this.issues_1).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.warning' call
        var this_23 = themed(this_22, BannerSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_24 = themed(this_23, WarningSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_28 = new (RowOrCol())(this_24.get_context_h02k06_k$());
        ensureOutermostElement(element_28);
        this_24.willAddChild_hz2iwc_k$(element_28);
        element_28.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_29 = new (TextView())(element_28.get_context_h02k06_k$());
        ensureOutermostElement(element_29);
        element_28.willAddChild_hz2iwc_k$(element_29);
        var tmp_64 = KMutableProperty0();
        var tmp_65 = TextView$_get_content_$ref_4pzcwl(element_29);
        var tmp_66 = getPropertyCallableRef('content', 0, tmp_64, tmp_65, TextView$_set_content_$ref_pketfb(element_29));
        element_29.invoke_bnq13k_k$(tmp_66, ($this$invoke) => joinToString($this$invoke.invoke_r7m7el_k$(this.issues_1), '\n'));
        element_29.onStartup_vrxh3i_k$();
        element_28.addChild_2qpft2_k$(element_29);
        element_28.onStartup_vrxh3i_k$();
        this_24.addChild_2qpft2_k$(element_28);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_30 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_30);
        element.willAddChild_hz2iwc_k$(element_30);
        element_30.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_30);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_25 = shownWhen(element, VOID, VOID, NewChildPlacementPage$render$lambda_37);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_31 = new (Space())(this_25.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_31);
        this_25.willAddChild_hz2iwc_k$(element_31);
        element_31.onStartup_vrxh3i_k$();
        this_25.addChild_2qpft2_k$(element_31);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'NewChildPlacementPage', VOID, VOID, [Page(), CanBlockBack()]);
    NewChildPlacementPageClass = $;
  }
  return NewChildPlacementPageClass;
}
//region block: exports
export {
  TextInput$_get_hint_$ref_uvwrja as TextInput$_get_hint_$ref_uvwrja1fc638uz6ch32,
  TextInput$_set_hint_$ref_i30g2i as TextInput$_set_hint_$ref_i30g2i16lyp5h9o9qbl,
  NewChildPlacementPage as NewChildPlacementPage3k697wogz82ti,
};
//endregion

//# sourceMappingURL=NewChildPlacementPage.mjs.map
